import _ from 'lodash'
import B_TV_MASONRY_CONFIG from './config'

class BusinessTvMasonryClass {
    constructor() {
        this.DOM = {
            section: B_TV_MASONRY_CONFIG.section,
            headlands: B_TV_MASONRY_CONFIG.headlands,
            chapters: B_TV_MASONRY_CONFIG.chapters
        }

        this.DOM.section ? this.init() : null
    }

    init() {
        this._listeners()
        console.log( this )
    }

    _listeners() {
        this.DOM.headlands.forEach( ( headland ) => { headland.addEventListener( 'click', this._headlandState.bind( this ) )})
        this.DOM.chapters.forEach( ( chapter ) => { chapter.addEventListener( 'click', this._chapterState.bind( this ) )})
    }

    _chapterState() {
        const chapter = _.findAncestor( event.currentTarget, 'chapter' )
        _.containClass( chapter, 'is--active' ) ? _.removeClass( chapter, 'is--active' ) : _.addClass( chapter, 'is--active' )
    }

    _headlandState() {
        const headland = _.findAncestor( event.currentTarget, 'headland' )
        _.containClass( headland, 'is--active' ) ? _.removeClass( headland, 'is--active' ) : _.addClass( headland, 'is--active' )
    }
}

const B_TV_MASONRY = new BusinessTvMasonryClass()
export default B_TV_MASONRY